import { handleActions } from 'redux-actions';
import { formsLoaded, formSelect } from '../actions';

const initialState = {
    existing: [],
    selected: {},
};

export default handleActions(
    {
        [formsLoaded]: (state, action) => ({
            ...state,
            existing: action.payload,
        }),
        [formSelect]: (state, action) => ({
            ...state,
            selected: action.payload,
        }),
    },
    initialState,
);
